module.exports = __webpack_public_path__ + "7f7aba830a1b9d63c5dd4cf290405ad3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/lisa_bruehlmann.jpg
// module id = 113
// module chunks = 0